import { useTheme } from "@mui/material";
import Swal from "sweetalert2";

const SweetAlertConfirm = (title, text, confirmCallback) => {
  const theme = useTheme;
  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#800000",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      confirmCallback();
    }
  });
};

export default SweetAlertConfirm;
